/**
 * Event Modal
 * @format
 */

import React, { useState, useEffect } from 'react';
import ModalWrapper from '@components/modals/modal-wrapper';

const SimpleEventModal = (): JSX.Element => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [eventContent, setEventContent] = useState<string | null>(null);
  const [eventImage, setEventImage] = useState<string | null>(null);
  const [eventRegistrationUrl, setEventRegistrationUrl] = useState<
    string | null
  >(null);
  const [eventRegistrationText, setEventRegistrationText] = useState<
    string | null
  >(null);

  /**
   * Setup Cards.
   */
  const setupCards = (eventCards: NodeListOf<Element>): void => {
    eventCards.forEach((link: Element) => {
      link.addEventListener('click', (event): void => {
        event.preventDefault();
        const card: Element | null = link.closest('.event-card');
        if (card) {
          const content: Element | null = card.querySelector('.text-container');
          if (content) {
            setEventContent(content.innerHTML);
          }

          const eventImage: Element | null =
            card.querySelector('.img-container');
          if (eventImage) {
            setEventImage(eventImage.innerHTML);
          }
        }

        setShowModal(true);
      });
    });
  };

  /**
   * Use Effect.
   */
  useEffect(() => {
    const eventCards: NodeListOf<Element> = document.querySelectorAll(
      '.event-card .featured-link'
    );
    if (eventCards.length > 0) {
      setupCards(eventCards);
    }

    const registerLink: HTMLAnchorElement | null =
      document.querySelector('.registration-link');
    if (registerLink) {
      setEventRegistrationUrl(registerLink.href);
      setEventRegistrationText(registerLink.innerText);
    }
  }, []);

  /**
   * Render.
   */
  return (
    <ModalWrapper showModal={showModal} setShowModal={setShowModal}>
      <>
        {eventImage && (
          <div
            className="img-container"
            dangerouslySetInnerHTML={{ __html: eventImage }}
          />
        )}
        {eventContent && (
          <div
            className="event-modal-content"
            dangerouslySetInnerHTML={{ __html: eventContent }}
          />
        )}
        {eventRegistrationUrl && (
          <div className="registration-link-container">
            <a
              href={eventRegistrationUrl}
              target="_blank"
              className="btn-primary squared"
              rel="noreferrer noopener">
              {eventRegistrationText}
            </a>
          </div>
        )}
      </>
    </ModalWrapper>
  );
};
export default SimpleEventModal;
